import { clamp } from './math';
import { parseElementHtml } from './html';
import { GestureList, Click } from './GestureHelper';


function makeElement(baseClassName) {
  return parseElementHtml(`
    <div class="${baseClassName}">
      <div class="${baseClassName}__track">
        <div class="${baseClassName}__position-fill"></div>
      </div>
      <button type="button" class="${baseClassName}__btn ${baseClassName}__btn-reset">
        <span class="sr-only">Reset zoom</span>
      </button>
      <button type="button" class="${baseClassName}__btn ${baseClassName}__btn-zoom ${baseClassName}__btn-zoom--zoom-in">
        <span class="sr-only">Zoom in</span>
      </button>
      <button type="button" class="${baseClassName}__btn ${baseClassName}__btn-zoom ${baseClassName}__btn-zoom--zoom-out">
        <span class="sr-only">Zoom out</span>
      </button>
    </div>
  `);
}

const ZOOM_INCREMENT = 0.2;

class ViewportZoomControl {

  constructor(opts = {}) {
    const options = Object.assign({
      initialScale: 1,
      baseClassName: 'viewport-zoom-control',
      onUpdate: null,
      onReset: null,
    }, opts);

    this.bindMethods();

    this.options = options;
    this.value = options.initialScale;
    this.btnZoomInEnabled = true;
    this.btnZoomOutEnabled = true;

    this.el = makeElement(options.baseClassName);

    this.positionFillEl = this.el.querySelector(`.${options.baseClassName}__position-fill`);
    this.btnZoomInEl = this.el.querySelector(`.${options.baseClassName}__btn-zoom--zoom-in`);
    this.btnZoomOutEl = this.el.querySelector(`.${options.baseClassName}__btn-zoom--zoom-out`);
    const btnReset = this.el.querySelector(`.${options.baseClassName}__btn-reset`);

    this.gestures = new GestureList([
      new Click(btnReset, (event) => {
        event.preventDefault();
        this.reset();
      }),
      new Click(this.btnZoomInEl, (event) => {
        event.preventDefault();
        this.zoomIn();
      }),
      new Click(this.btnZoomOutEl, (event) => {
        event.preventDefault();
        this.zoomOut();
      }),
    ]);

    this.updateDisplay();
  }

  startListening() {
    this.gestures.start();
  }

  stopListening() {
    this.gestures.stop();
  }

  bindMethods() {
    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
    this.reset = this.reset.bind(this);
  }

  setValue(val, internal = false) {
    const value = clamp(val, 0, 1);

    if (value === this.value) {
      return;
    }

    this.value = value;
    this.updateDisplay();

    if (internal === true) {
      const callback = this.options.onUpdate;
      if (callback) {
        callback(value);
      }
    }
  }

  reset() {
    if (this.options.onReset) {
      this.options.onReset();
    }
  }

  updateDisplay() {
    window.requestAnimationFrame(() => {
      const value = this.value;

      this.positionFillEl.style.width = `${value * 100}%`;

      if (value === 1) {
        if (this.btnZoomInEnabled === true) {
          this.btnZoomInEl.setAttribute('disabled', 'true');
          this.btnZoomInEnabled = false;
        }
      } else {
        if (this.btnZoomInEnabled === false) {
          this.btnZoomInEl.removeAttribute('disabled');
          this.btnZoomInEnabled = true;
        }
      }

      if (value === 0) {
        if (this.btnZoomOutEnabled === true) {
          this.btnZoomOutEl.setAttribute('disabled', 'true');
          this.btnZoomOutEnabled = false;
        }
      } else {
        if (this.btnZoomOutEnabled === false) {
          this.btnZoomOutEl.removeAttribute('disabled');
          this.btnZoomOutEnabled = true;
        }
      }
    });
  }

  zoomIn() {
    this.setValue(this.value + ZOOM_INCREMENT, true);
  }

  zoomOut() {
    this.setValue(this.value - ZOOM_INCREMENT, true);
  }

  destroy() {
    this.stopListening();
    this.handlers = null;
  }

}


export default ViewportZoomControl;



// WEBPACK FOOTER //
// ./V7/syos/utils/ViewportZoomControl.js